export default function EurIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.554 15.536C17.0074 16.0827 16.3415 16.4953 15.6085 16.7412C14.8755 16.9872 14.0955 17.0598 13.3298 16.9534C12.564 16.847 11.8333 16.5645 11.1952 16.128C10.7422 15.8182 10.3446 15.4367 10.0172 15H13L14 13H9.1265C9.08763 12.8245 9.0626 12.6732 9.05001 12.562C9.00769 12.1882 9.00769 11.8108 9.05001 11.437C9.06259 11.3259 9.0877 11.175 9.12666 11H13L14 9H10.0183C10.3454 8.56323 10.7428 8.18173 11.1956 7.87178C11.8337 7.43497 12.5644 7.15218 13.3303 7.04566C14.0962 6.93914 14.8764 7.01179 15.6095 7.2579C16.3426 7.504 17.0085 7.91685 17.555 8.46397L18.969 7.04997C18.1392 6.22045 17.1143 5.61271 15.9884 5.28257C14.8625 4.95243 13.6717 4.91047 12.5253 5.16055C11.379 5.41062 10.3138 5.94472 9.42773 6.71378C8.6956 7.3492 8.10508 8.12818 7.69131 9H5L4 11H7.07295C7.06111 11.1081 7.05531 11.2026 7.04986 11.2914L7.04986 11.2914L7.04986 11.2914C7.0468 11.3413 7.04385 11.3893 7.04001 11.437C7.00977 11.8117 7.00977 12.1882 7.04001 12.563C7.04385 12.6106 7.0468 12.6585 7.04986 12.7083C7.05532 12.7972 7.06113 12.8918 7.073 13H5L4 15H7.69182C8.10551 15.8713 8.69576 16.6498 9.42746 17.2849C10.3134 18.054 11.3784 18.5881 12.5246 18.8382C13.6709 19.0884 14.8615 19.0466 15.9874 18.7167C17.1132 18.3867 18.1381 17.7792 18.968 16.95L17.554 15.536Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
